import * as React from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
    root: {
        position: 'sticky',
        bottom: 0,
        zIndex: 4,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        flexWrap: 'wrap',
        marginTop: '4px',
        paddingTop: '12px',
        paddingBottom: 'calc(12px + env(safe-area-inset-bottom, 0px))',
        paddingLeft: '16px',
        paddingRight: '16px',
        backgroundColor: tokens.colorNeutralBackground1,
        border: `1px solid ${tokens.colorNeutralStroke2}`,
        borderRadius: tokens.borderRadiusLarge,
        boxShadow: tokens.shadow8,
    },
    group: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flexWrap: 'wrap',
    },
    end: {
        marginLeft: 'auto',
    },
});

export interface IFormFooterProps {
    start?: React.ReactNode;
    end?: React.ReactNode;
}

/** Sticky action bar for long forms; stays reachable on phones. */
const FormFooter: React.FC<IFormFooterProps> = ({ start, end }) => {
    const styles = useStyles();
    return (
        <div className={styles.root}>
            <div className={styles.group}>{start}</div>
            <div className={`${styles.group} ${styles.end}`}>{end}</div>
        </div>
    );
};

export default FormFooter;
